import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { TimeSlotStoreAction } from "src/components/shared-components/enum/enumStoreAction";

//#region Time slot
/**
 * Reseet time slot state and unset key storage
 */
export const timeSlotUnsetKeyStorage = createAction(
  TimeSlotStoreAction.TIMESLOT_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const timeSlotLoadInitStartAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_INIT_START
);

/**
 * Action to load full list of time slot
 */
export const timeSlotLoadListFromApiAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_FROM_API
);

/**
 * Action to load last modified list of time slot
 */
export const timeSlotLoadLastModifiedFromApiAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_LAST_MODIFIED_FROM_API,
  props<{ timeSlotObject: GenericApiData }>()
);

/**
 * Action time slot load success
 */
export const timeSlotLoadSuccessAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_SUCCESS,
  props<{ timeSlotObject: GenericApiData }>()
);

/**
 * Action to handle generic error in time slots loading from API
 */
export const timeSlotLoadErrorHandlingAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_ERROR_HANDLING,
  props<{ error: HttpErrorResponse }>()
);


/**
 * Action to populate the time slots list with old, pre-existent data (after API error).
 */
export const timeSlotListPopulateWithOldDataAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_OLD_DATA,
  props<{ oldTimeSlotObject: GenericApiData }>()
);

/**
 * Action time slot load error
 */
export const timeSLotLoadErrorAction = createAction(
  TimeSlotStoreAction.TIMESLOT_LOAD_ERROR
);
//#endregion




//#region Group Time slot
/**
 * Reseet time slot state and unset key storage
 */
export const groupTimeSlotUnsetKeyStorage = createAction(
  TimeSlotStoreAction.TIMESLOT_GROUP_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const groupTimeSlotLoadInitStartAction = createAction(
  TimeSlotStoreAction.TIMESLOT_GROUP_LOAD_INIT_START
);

/**
 * Action to load full list of group time slot
 */
export const groupTimeSlotLoadListFromApiAction = createAction(
  TimeSlotStoreAction.TIMESLOT_GROUP_LOAD_FROM_API
);

/**
 * Action to load last modified list of group time slot
 */
export const groupTimeSlotLoadLastModifiedFromApiAction = createAction(
  TimeSlotStoreAction.TIMESLOT_GROUP_LOAD_LAST_MODIFIED_FROM_API,
  props<{ groupTimeSlotObject: GenericApiData }>()
);

/**
 * Action group time slot load success
 */
export const groupTimeSlotLoadSuccessAction = createAction(
  TimeSlotStoreAction.TIMESLOT_GROUP_LOAD_SUCCESS,
  props<{ groupTimeSlotObject: GenericApiData }>()
);

/**
 * Action group time slot load error
 */
export const groupTimeSLotLoadErrorAction = createAction(
  TimeSlotStoreAction.TIMESLOT_GROUP_LOAD_ERROR
);
//#endregion
